import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

// Fetch all pre-reqs for a given ICT ID
export const fetchPreReqsByIctId = createAsyncThunk(
  "ictPreReq/fetchPreReqsByIctId",
  async (ictId, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(`/ictData/${ictId}/pre-reqs/`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
// insert
export const insertPreReq = createAsyncThunk(
  "ictPreReq/insertPreReq",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post("/pre-reqs/", payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
// Delete a pre-req
export const deletePreReq = createAsyncThunk(
  "ictPreReq/deletePreReq",
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`/pre-reqs/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update pre-req status (PATCH)
export const patchPreReqStatus = createAsyncThunk(
  "ictPreReq/patchPreReqStatus",
  async ({ pr_id, status }, { rejectWithValue }) => {
    try {
      const res = await apiClient.patch(`/pre-reqs/${pr_id}/status`, { status });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Optional: Update full pre-req
export const updatePreReq = createAsyncThunk(
  "ictPreReq/updatePreReq",
  async ({ pr_id, data }, { rejectWithValue }) => {
    try {
      const res = await apiClient.put(`/pre-reqs/${pr_id}`, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Reducer setup
const ictPreReqSlice = createSlice({
  name: "ictPreReq",
  initialState: {
    preReqs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(insertPreReq.pending, (state) => {
        state.loading = true;
      })
      .addCase(insertPreReq.fulfilled, (state, action) => {
        state.loading = false;
        state.preReqs.push(action.payload);
      })
      .addCase(insertPreReq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchPreReqsByIctId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPreReqsByIctId.fulfilled, (state, action) => {
        state.loading = false;
        state.preReqs = action.payload;
      })
      .addCase(fetchPreReqsByIctId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePreReq.fulfilled, (state, action) => {
        state.preReqs = state.preReqs.filter((req) => req.id !== action.payload);
      })

      .addCase(patchPreReqStatus.fulfilled, (state, action) => {
        const index = state.preReqs.findIndex((r) => r.id === action.payload.id);
        if (index !== -1) {
          state.preReqs[index] = action.payload;
        }
      })

      .addCase(updatePreReq.fulfilled, (state, action) => {
        const index = state.preReqs.findIndex((r) => r.id === action.payload.id);
        if (index !== -1) {
          state.preReqs[index] = action.payload;
        }
      });
  },
});

export default ictPreReqSlice.reducer;
